/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const DefaultCourseTaRoleSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('DEFAULT_COURSE_TA_ROLE')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ parsers.exactly('Full TA', 'Non-Editing TA')),
    ],
]);
export class DefaultCourseTaRoleSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return DefaultCourseTaRoleSettingParser.decode(input).map(res => new DefaultCourseTaRoleSetting(res));
    }
    static unsafeDecode(input) {
        return DefaultCourseTaRoleSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return DefaultCourseTaRoleSettingParser.encode(data);
    }
    static schema() {
        return DefaultCourseTaRoleSettingParser.schema();
    }
}
